import React from "react";
import { Row, Col, Card, CardBody } from "reactstrap";

const KPICards = ({ data }) => {
  // Add console logging to debug
  console.log("🎯 KPICards received:", data);
  
  // Extract data from the correct nested structure
  const summary = data.summary || {};
  const counts = data.counts || {};
  
  const kpis = [
    {
      title: "Total Revenue",
      value: summary.total_revenue || 0,
      currency: true,
      color: "success",
      icon: "💰",
      change: data.revenue_change || 0
    },
    {
      title: "Total Cost",
      value: Math.abs(summary.total_expenses || 0), // Make positive for display
      currency: true,
      color: "danger",
      icon: "💸",
      change: data.cost_change || 0
    },
    {
      title: "Net Profit",
      value: summary.net_profit || 0,
      currency: true,
      color: summary.net_profit >= 0 ? "primary" : "danger",
      icon: "📊",
      change: data.profit_change || 0
    },
    {
      title: "Total de Proeyctos",
      value: counts.total_projects || 0,
      currency: false,
      color: "info",
      icon: "📋",
      change: 0
    },
    {
      title: "Avg Project Margin",
      value: summary.profit_margin || 0,
      currency: false,
      suffix: "%",
      color: summary.profit_margin >= 0 ? "success" : "danger",
      icon: "📈",
      change: data.margin_change || 0
    }
  ];

  const formatNumber = (num, currency = false, suffix = "") => {
    if (currency) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(num);
    }
    return num.toLocaleString() + suffix;
  };

  const getChangeColor = (change) => {
    if (change > 0) return "text-success";
    if (change < 0) return "text-danger";
    return "text-muted";
  };

  const getChangeIcon = (change) => {
    if (change > 0) return "↑";
    if (change < 0) return "↓";
    return "→";
  };

  return (
    <Row>
      {kpis.map((kpi, index) => (
        <Col lg="4" md="6" key={index} className="mb-3">
          <Card className={`border-left-${kpi.color}`} style={{ borderLeft: `4px solid` }}>
            <CardBody>
              <Row className="align-items-center">
                <Col xs="3">
                  <div style={{ fontSize: '2.5rem' }}>{kpi.icon}</div>
                </Col>
                <Col xs="9">
                  <div className="text-muted small text-uppercase mb-1">
                    {kpi.title}
                  </div>
                  <div className="h4 mb-0 font-weight-bold">
                    {formatNumber(kpi.value, kpi.currency, kpi.suffix)}
                  </div>
                  {kpi.change !== undefined && kpi.change !== 0 && (
                    <div className={`small ${getChangeColor(kpi.change)}`}>
                      {getChangeIcon(kpi.change)} {Math.abs(kpi.change).toFixed(1)}% vs previous period
                    </div>
                  )}
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default KPICards;